var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.3","d":"M71.5 7.14013e-06L55 5.67235e-06L44 22.793L44 56.9824L77 56.9824L77 22.793L60.5 22.793L71.5 7.14013e-06ZM27.5 3.22605e-06L11 1.75827e-06L1.05668e-05 22.793L7.62939e-06 56.9824L33 56.9824L33 22.793L16.5 22.793L27.5 3.22605e-06Z","fill":"#58B51A"}));
}

Quote.defaultProps = {"width":"77","height":"57","viewBox":"0 0 77 57","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
